import React from 'react';
import { ORGAN_DISPLAY_NAMES, OrganEnum, OrganQualityEnum } from '../../clients/viewer';
import ToggleGroup from '../ToggleGroup';

const LABELS = { on: 'Good', off: 'Poor' };

interface QualityToggleProps {
  value?: OrganQualityEnum;
  onChange: (value?: OrganQualityEnum) => void;
  disabled?: boolean;
  organ: OrganEnum;
}

/**
 * The OrganQualityEnum <-> boolean mapping lives here, at the boundary, so ToggleGroup
 * stays boolean-valued (plan D-2). develop reached the same component by a three-level
 * relative import into DiagnosisButton/ (QualityToggle.tsx:3); M3 relocated it to
 * components/ToggleGroup.tsx, where it is shared in the directory structure and not only
 * in fact.
 */
export default function QualityToggle({ value, onChange, disabled, organ }: QualityToggleProps) {
  return (
    <ToggleGroup
      value={value === undefined ? undefined : value === OrganQualityEnum.GOOD}
      onChange={next =>
        onChange(
          next === undefined
            ? undefined
            : next
              ? OrganQualityEnum.GOOD
              : OrganQualityEnum.POOR
        )
      }
      disabled={disabled}
      label={`${ORGAN_DISPLAY_NAMES[organ]} quality`}
      labels={LABELS}
    />
  );
}
